export const WarrantyWarningRouting = [
  {
    path: "/warranty/warranty-warning/list",
    name: "warranty-warning-list",
    meta: { title: "保修预警" },
    component: () => import("@/views/warranty/warranty-warning/list/index.vue"),
  },
];
